function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { connect, useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { cmsActions } from '../../reducers/cms.reducer';
import useHasPermission from '../../helpers/hooks/useHasPermission';
import UserData from './user/User.context';
import UserEmail from './user/UserEmail.react';
import UserDetails from './user/UserDetails.react';
import UserPassword from './user/UserPassword.react';
import UserPermissions from './user/UserPermissions.react';
import UserDelete from './user/UserDelete.react';
import AccessRestricted from '../app/routing/AccessRestricted.react';

// TODO :: Stop if app / type is not in constants
// TODO :: make call with pageID to get latest article
var User = function User(_ref) {
  var _user$permissions;
  var usersAction = _ref.usersAction;
  var _useParams = useParams(),
    userID = _useParams.userID;
  var cmsUsers = useSelector(function (s) {
    return s.cms.users || {};
  });
  var user = useSelector(function (s) {
    var _s$auth;
    return ((_s$auth = s.auth) === null || _s$auth === void 0 ? void 0 : _s$auth.user) || {};
  });
  var _useState = useState({
      userID: null,
      email: '',
      permissions: [],
      profile: {}
    }),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];

  // TODO :: get individual user
  useEffect(function () {
    usersAction({
      userID: userID
    });
  }, [userID]);
  useEffect(function () {
    var user = Object.values(cmsUsers).find(function (x) {
      return x._id === userID;
    });
    if (user) {
      var _user$email$find;
      setState({
        userID: user._id,
        email: (_user$email$find = user.email.find(function (x) {
          return x.primary;
        })) === null || _user$email$find === void 0 ? void 0 : _user$email$find.address,
        permissions: user.permissions,
        profile: user.profile
      });
    }
  }, [userID, cmsUsers]);
  if (!useHasPermission('view-users') && userID !== user.id) return /*#__PURE__*/React.createElement(AccessRestricted, null);
  return /*#__PURE__*/React.createElement(UserData.Provider, {
    value: [state, setState]
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "page__content--block"
  }, /*#__PURE__*/React.createElement(NavLink, {
    className: "page__content--back",
    to: "/users"
  }, "View All")), /*#__PURE__*/React.createElement(UserEmail, null), /*#__PURE__*/React.createElement(UserDetails, null), /*#__PURE__*/React.createElement(UserPassword, null), (user === null || user === void 0 ? void 0 : (_user$permissions = user.permissions) === null || _user$permissions === void 0 ? void 0 : _user$permissions.find(function (y) {
    return y.key === 'view-permissions' && y.value === true;
  })) && /*#__PURE__*/React.createElement(UserPermissions, null), /*#__PURE__*/React.createElement(UserDelete, null)));
};
var mdtp = {
  usersAction: cmsActions.users
};
export default connect(null, mdtp)(User);